import { formatLastSeenRelative } from '../../../utils/presenceUtils';

const MS_IN_HOUR = 3600000;
const MS_IN_DAY = 24 * MS_IN_HOUR;
const MS_IN_YEAR = 365 * MS_IN_DAY;

export function formatStatusText({ online, lastSeen, locale, t }) {
    if (online) {
        return t('presence.status.online');
    }

    if (!lastSeen) {
        return t('presence.status.offline');
    }

    const parsed = Date.parse(lastSeen);
    if (Number.isNaN(parsed)) {
        return t('presence.status.offline');
    }

    const diffMs = Date.now() - parsed;
    if (diffMs >= MS_IN_YEAR) {
        const formattedDate = new Intl.DateTimeFormat(locale || undefined, {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
        }).format(parsed);
        return t('presence.status.lastSeenDateWithYear', { date: formattedDate });
    }

    if (diffMs >= 2 * MS_IN_DAY) {
        const formattedDate = new Intl.DateTimeFormat(locale || undefined, {
            month: 'long',
            day: 'numeric',
        }).format(parsed);
        return t('presence.status.lastSeenDate', { date: formattedDate });
    }

    if (diffMs >= MS_IN_DAY) {
        return t('presence.status.lastSeenYesterday');
    }

    const relative = formatLastSeenRelative(lastSeen, { locale });
    if (relative) {
        return t('presence.status.lastSeen', { relative });
    }

    return t('presence.status.offline');
}
